var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgPreviewIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9.64 9.64 0 0 0-9 6.136 9.64 9.64 0 0 0 9 6.137h.9c-.082-.246-.082-.491-.082-.819 0-.49.082-.9.164-1.39-.327.082-.655.163-.982.163-2.29 0-4.09-1.8-4.09-4.09 0-2.292 1.8-4.092 4.09-4.092s4.09 1.8 4.09 4.091c0 .246 0 .491-.08.737.572-.164 1.145-.328 1.717-.328.982 0 1.882.246 2.7.819.246-.41.41-.819.573-1.228A9.64 9.64 0 0 0 9 0Zm0 3.682c-1.39 0-2.455 1.063-2.455 2.454C6.545 7.527 7.61 8.591 9 8.591c1.39 0 2.454-1.064 2.454-2.455 0-1.39-1.063-2.454-2.454-2.454Zm5.727 9.818v-1.636h-3.273v-1.637h3.273V8.591l2.455 2.455-2.455 2.454Z",
    fill: "#fff"
  })));
};
export { SvgPreviewIcon as ReactComponent };
export default __webpack_public_path__ + "acdd6833e9677d989f860f458f51d7be.svg";